import React from 'react';
import _ from 'lodash';
import { taxLabel } from '../../../../helpers/taxHelper';
import Currency from '../../../../helpers/currency';
import { InternalLink } from '../../../components/form-elements/Link';

const CheckoutTotalPrice = ({ cart, type, deleteCoupon }) => {
    const stats = cart?.stats;
    const coupon = cart?.coupon;

    const discount = stats?.[type]?.discount;

    return (
        <div className="total_price">
            <div className="payment_container">
                {coupon && discount && (
                    <div className="uk-flex uk-flex-right uk-margin-remove">
                        {deleteCoupon && <button className="uk-close uk-icon" type="button" data-uk-close="" onClick={deleteCoupon} />}
                        <div className="subtotal price">Gutschein {coupon?.code ? `"${coupon.code}"` : coupon.couponsCodes ? `"${coupon.couponsCodes[0].code}"` :''}</div>
                        <div className="uk-text-right uk-width-1-5">
                            -<Currency quantity={discount} />
                        </div>
                    </div>
                )}
                <div className="uk-flex uk-flex-right uk-margin-remove">
                    <div className="subtotal price">Zwischensumme</div>
                    <div className="uk-text-right uk-width-1-4">
                        <Currency quantity={_.get(stats, `${type}.grossProducts`, 0)} />
                    </div>
                </div>
                {type === 'onlineKauf' && (
                    <div className="uk-flex uk-flex-right uk-margin-remove">
                        <div className="subtotal">
                            {' '}
                            zzgl.{' '}
                            <InternalLink to="/lieferUndVersand" newTab>
                                {' '}
                                Versandkosten{' '}
                            </InternalLink>
                        </div>
                        <div className="uk-text-right uk-width-1-5">
                            <Currency quantity={_.get(stats, `${type}.shippingCost`, 0)} />
                        </div>
                    </div>
                )}
                <div className="uk-flex uk-flex-right uk-margin-remove">
                    <div className="subtotal">Enthaltene MwSt. {taxLabel()}</div>
                    <div className="uk-text-right uk-width-1-4">
                        <Currency quantity={_.get(stats, `${type}.taxTotal`, 0)} />
                    </div>
                </div>
                <div className="payment_container uk-flex uk-flex-right  gesamtsumme uk-margin-small-top">
                    <div className="subtotal price">Gesamtsumme</div>
                    <div className="uk-width-1-4 uk-text-right price">
                        <Currency quantity={+_.get(stats, `${type}.grossTotal`, 0)} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutTotalPrice;
